import { LocaleEnum } from '@systemeio/ui'

export const getContactSupportLink = (locale: LocaleEnum) => `/${locale}/support/contact-us`
